core-dropdown {
  display: inline-flex;
}

.core-dropdown {
  display: flex;
}

.core-dropdown .dropdown-wrapper {
  position: relative;
}

.core-dropdown .dropdown-wrapper:hover {
  cursor: pointer;
}

.core-dropdown .trigger-element {
  display: flex;
}

/* ITEMS LIST */
.core-dropdown-items-list {
  position: absolute;
  top: 0;
  left: 0;
  width: max-content;
  z-index: 9999;
  overflow-y: auto;
  box-sizing: border-box;
  border-radius: var(--number-radius-large);
  background-color: var(--color-neutral-background-strong);
  text-align: left;
  box-shadow: var(--effect-drop-medium);
  opacity: 1;
  transform: translateY(0), translateX(0);
  transition: opacity var(--motion-duration-medium) var(--motion-easing-move),
  transform var(--motion-duration-medium) var(--motion-easing-move);
}

/* width */
.core-dropdown.dropdown-width--small .core-dropdown-items-list {
  width: 12.5rem; /* 200px */
}
.core-dropdown.dropdown-width--medium .core-dropdown-items-list {
  width: 17.5rem; /* 280px */
}
.core-dropdown.dropdown-width--large .core-dropdown-items-list {
  width: 22.5rem; /* 360px */
}

/* direction */
.core-dropdown-items-list.items-list--hidden {
  opacity: 0;
}

.core-dropdown-items-list.items-list--hidden.items-list--top {
  transform: translateY(0.5rem);
}

.core-dropdown-items-list.items-list--hidden.items-list--bottom {
  transform: translateY(-0.5rem);
}

.core-dropdown .core-dropdown-items-list {
  display: none;
}

.core-dropdown-items-list ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.core-dropdown-items-list {
  max-height: 21.5rem;
  padding: var(--number-spacing-4xsmall) 0;
}

.core-dropdown-items-list .item {
  display: flex;
  border-radius: var(--number-radius-small);
  padding: var(--number-spacing-2xsmall);
  margin: 0 var(--number-spacing-4xsmall); /* adding space on children to let the divider taking 100% width */
  transition: background-color var(--motion-duration-fast) var(--motion-easing-move),
    color var(--motion-duration-fast) var(--motion-easing-move),
    border var(--motion-duration-fast) var(--motion-easing-move);
}

.core-dropdown-items-list .item:not(.item--disabled), .core-dropdown-items-list .item:not(.item--disabled) label {
  cursor: pointer;
}

.core-dropdown-items-list .item:not(.item--disabled):not(.item--selected) {
  color: var(--color-selection-secondary-content-default);
}

.core-dropdown-items-list .item--disabled {
  color: var(--color-global-all-disabled-strong);
}

.core-dropdown-items-list .item--disabled:hover, .core-dropdown-items-list .item--disabled label {
  cursor: not-allowed;
}

.core-dropdown-items-list .item .item-indicator {
  display:flex;
}

.core-dropdown-items-list .item .item-content {
  display: flex;
  flex-grow: 1;
  gap: var(--number-spacing-2xsmall)
}

.core-dropdown-items-list .item .icon-box {
  display: flex;
  align-self: flex-start;
  padding: var(--number-spacing-5xsmall);
  animation: appear var(--motion-duration-medium) var(--motion-easing-enter);
}

.core-dropdown-items-list .item .item-content .text-box {
  display: flex;
  flex-direction: column;
}

.core-dropdown-items-list .item:not(.item--disabled) .item-content .item-description {
  color: var(--color-neutral-content-medium);
}

.core-dropdown-items-list .item:not(.item--disabled):not(.item--selected):hover, .core-dropdown-items-list .item:not(.item--disabled):not(.item--selected):focus-visible {
  background-color: var(--color-selection-secondary-background-interacting);
}

.core-dropdown-items-list .item:focus-visible {
  outline: 2px solid var(--color-global-border-focus);
  outline-offset: 2px;
}

.core-dropdown-items-list .item--selected {
  background-color: var(--color-selection-secondary-background-selected);
  color: var(--color-selection-secondary-content-selected);
}

/* Section */
.core-dropdown-items-list .section-header {
  display: flex;
  flex-direction: column;
  padding: var(--number-spacing-small) var(--number-spacing-2xsmall) var(--number-spacing-2xsmall) var(--number-spacing-2xsmall);
  margin: 0 var(--number-spacing-4xsmall); /* adding space on children to let the divider taking 100% width */
}
.core-dropdown-items-list .section-title {
  display: flex;
  color: var(--color-neutral-content-strong);
}
.core-dropdown-items-list .section-description {
  display: flex;
  color: var(--color-neutral-content-medium);
}
.core-dropdown-section.core-dropdown-section--divided {
  position: relative;
}
.core-dropdown-section.core-dropdown-section--divided::before {
  content: '';
  display: flex;
  top: 0;
  left: 0;
  width: 100%;
  height: 1px;
  margin: var(--number-spacing-4xsmall) 0;
  background-color: var(--color-neutral-border-medium);
}

/* Checkbox specificities */
.core-dropdown-items-list .item:hover .core-checkbox:not(.checkbox--disabled) .checkbox-box,
.core-dropdown-items-list .item:focus-visible .core-checkbox:not(.checkbox--disabled) .checkbox-box {
  border: 1px solid var(--color-selection-primary-border-interacting);
  background-color: var(--color-selection-primary-background-interacting);
}

.core-dropdown-items-list .item.item--selected .core-checkbox .checkbox-label {
  color: var(--color-selection-secondary-content-selected);
}

.core-dropdown-items-list .item:hover .core-checkbox:not(.checkbox--disabled) .checkbox-box svg,
.core-dropdown-items-list .item:focus-visible .core-checkbox:not(.checkbox--disabled) .checkbox-box svg {
  fill: var(--color-selection-primary-content-interacting);
}

/* Action specificities */
.core-dropdown-items-list core-dropdown-action-item {
  display: flex;
  width: 100%;
  height: 100%;
}

.core-dropdown-items-list .item .action-item {
  display: flex;
  width: 100%;
  height: 100%;
}

@keyframes appear {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
